import axios from 'axios'

// Function to upload files
export const upload = (file: any) => {
  const formData = new FormData()
  formData.append('file', file)

  return axios.post(`${process.env.REACT_APP_API_URL}/aws/upload`, formData)
}
